import Icon from "../../../controls/Icon";
import bbcode from "../../../controls/bbcode";
import { truthy } from "../../../util/util";
import memoizeOne from "memoize-one";
import * as React from "react";
import { Overlay, Popover } from "react-bootstrap";
function nop() {
    // nop
}
class Description extends React.Component {
    mRef;
    mLongBB;
    shortBB = memoizeOne((short) => bbcode(short));
    constructor(props) {
        super(props);
        this.state = {
            open: false,
        };
    }
    render() {
        const { t, installed, short, source } = this.props;
        const popover = (React.createElement(Popover, { id: "popover-mod-description" },
            React.createElement("div", null, this.mLongBB),
            truthy(source) ? (React.createElement("a", { onClick: nop, className: "fake-link-disabled", title: t("Description is synchronized with an online source") },
                React.createElement(Icon, { name: "edit" }),
                t("Edit Description"))) : !installed ? (React.createElement("a", { onClick: nop, className: "fake-link-disabled", title: t("Description can only be changed for installed mods") },
                React.createElement(Icon, { name: "edit" }),
                t("Edit Description"))) : (React.createElement("a", { onClick: this.editDescription },
                React.createElement(Icon, { name: "edit" }),
                t("Edit Description")))));
        return (React.createElement("div", null,
            React.createElement(Overlay, { rootClose: true, placement: "left", onHide: this.hide, show: this.state.open, target: this.getRef }, popover),
            React.createElement("a", { ref: this.setRef, onClick: this.toggle }, !short ? t("Description") : this.shortBB(short))));
    }
    editDescription = () => {
        this.props.startEditDescription(this.props.modId);
    };
    getRef = () => this.mRef;
    setRef = (ref) => {
        this.mRef = ref;
    };
    hide = () => {
        this.setState({ open: false });
    };
    toggle = () => {
        const { t } = this.props;
        if (!this.state.open) {
            this.mLongBB = bbcode(this.props.long || `<${t("No description")}>`);
        }
        this.setState({ open: !this.state.open });
    };
}
export default Description;
